module.exports = __webpack_public_path__ + "static/img/notice.277f178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/notice.png
// module id = otZL
// module chunks = 69